import React from "react";
import { AlertTriangle, CheckCheck, Clock, Send } from "lucide-react";

const STYLES: Record<string, { label: string; cls: string; Icon: any }> = {
  sent: { label: "Sent", cls: "bg-stone-100 text-stone-700", Icon: Send },
  delayed: { label: "Delayed", cls: "bg-amber-50 text-amber-700", Icon: Clock },
  delivered: { label: "Delivered", cls: "bg-emerald-50 text-emerald-700", Icon: CheckCheck },
  bounced: { label: "Bounced", cls: "bg-rose-50 text-rose-700", Icon: AlertTriangle },
  complained: { label: "Marked as spam", cls: "bg-rose-50 text-rose-700", Icon: AlertTriangle },
};

export function DeliveryBadge({ i }: { i: any }) {
  const s = STYLES[i.delivery_status] || STYLES.sent;
  return (
    <span className="mt-1 inline-flex flex-wrap items-center gap-1">
      <span className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[11px] font-semibold ${s.cls}`} data-testid={`delivery-status-${i.id}`}>
        <s.Icon className="h-3 w-3" /> {s.label}
      </span>
      {i.delivery_detail && <span className="line-clamp-2 text-[11px] text-rose-700" title={i.delivery_detail} data-testid={`delivery-detail-${i.id}`}>{i.delivery_detail}</span>}
    </span>
  );
}

export function BouncedFlag({ l }: { l: any }) {
  return (
    <span className="mt-1 inline-flex items-center gap-1 rounded-sm bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-700" title={l.email_bounce_reason || ""} data-testid={`lead-bounced-${l.id}`}>
      <AlertTriangle className="h-3 w-3" /> {l.email_bounce_reason === "complained" ? "Marked as spam" : "Email bounced"}
    </span>
  );
}
